import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FilesControllerGetUserFiles$Params } from '@api/fn/files/files-controller-get-user-files';
import { FileDto, FileType } from '@api/models';
import { FilesService } from '@api/services';
import { ControlValueAccessorWrapperComponent } from '@shared/components/control-value-accessor-wrapper/control-value-accessor-wrapper.component';
import { FiltersData } from '@shared/components/datatable/datatable.component';
import {
   SelectDataSource,
   SelectField,
   SelectFieldComponent,
} from '@shared/components/select-field/select-field.component';
import { map } from 'rxjs';

type FilesSearchDto = FilesControllerGetUserFiles$Params & FiltersData;

@Component({
   selector: 'app-select-file-field',
   imports: [CommonModule, MatButtonModule, ReactiveFormsModule, FormsModule, SelectFieldComponent, MatIconModule],
   templateUrl: './select-file-field.component.html',
   styleUrl: './select-file-field.component.scss',
})
export class SelectFileFieldComponent
   extends ControlValueAccessorWrapperComponent<number | number[]>
   implements AfterViewInit
{
   @Input() label: string = '';
   @Input() type!: FileType;
   @Input() accept: string = 'image/*';
   @Input() upload: boolean = true;

   dataSource?: SelectDataSource<FilesSearchDto>;
   isUploading: boolean = false;

   errorMessages: Record<string, string> = {
      required: 'The field is required',
   };

   get isRequired(): boolean {
      return this.formControl.hasValidator(Validators.required);
   }

   constructor(private filesService: FilesService) {
      super();
   }

   ngAfterViewInit() {
      this.setupDataSource();
   }

   setupDataSource() {
      this.dataSource = new SelectDataSource<FilesSearchDto>()
         .setInitialFilters({
            type: this.type,
         })
         .onSearch((params) => this.filesService.filesControllerGetUserFiles(params).pipe(map(this.listToSelectField)));
   }

   listToSelectField(list: FileDto[]): SelectField[] {
      return list.map(
         (item, index) =>
            ({
               id: item.id,
               imageUrl: item.fileUrl,
               name: `File ${index + 1}`,
            }) as SelectField
      );
   }

   onFileUpload(event: any) {
      const file: File = event.target.files[0];
      if (file) {
         this.isUploading = true;
         this.subs = this.filesService
            .filesControllerUploadFile({
               body: {
                  file,
                  type: this.type,
               },
            })
            .subscribe({
               next: (res) => {
                  this.dataSource?.refresh();
                  this.formControl.setValue(res.id);
                  this.isUploading = false;
               },
               error: (err) => {
                  this.isUploading = false;
                  return err;
               },
            });
      }
   }
}
